import { Flex, Text } from '@chakra-ui/react';
import { SingleDatePicker } from '@/components/ui';
import { calculateAge } from '@/utils/age';
import type { OnboardingFormReturn } from '../useOnboardingForm';

/** Oldest selectable birth date; also bounds the year dropdown in the calendar. */
const MIN_BIRTH_DATE = new Date(new Date().getFullYear() - 120, 0, 1);

export function AgeStep({ form }: { form: OnboardingFormReturn }) {
  const { dateOfBirth, setDateOfBirth } = form;
  const age = calculateAge(dateOfBirth);

  return (
    <Flex direction="column" gap="3">
      <Text fontSize="md" color="volyx.textSecondary">
        Pick your date of birth. Organizations use it to check you meet the age requirements
        for an event.
      </Text>
      <SingleDatePicker
        popover
        showAge
        id="onboarding-date-of-birth"
        name="onboarding-date-of-birth"
        autoComplete="off"
        value={dateOfBirth}
        onChange={(date) => setDateOfBirth(date ?? '')}
        minDate={MIN_BIRTH_DATE}
        maxDate={new Date()}
        placeholder="Select your date of birth"
      />
      <Text fontSize="xs" color="volyx.textSecondary">
        {age !== null ? `You are ${age} years old.` : 'Required to continue.'}
      </Text>
    </Flex>
  );
}
